
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M8 8.4a2.4 2.4 0 00-2.4 2.4V14A.8.8 0 114 14v-3.228a2.824 2.824 0 01-.661.016.805.805 0 01-.139.012h-.343c-.694 0-1.257.563-1.257 1.257V13.2a.8.8 0 11-1.6 0v-1.143c0-1.017.531-1.91 1.331-2.416a2.8 2.8 0 013.48-4.166 3.2 3.2 0 116.377 0 2.8 2.8 0 013.48 4.166c.8.507 1.332 1.4 1.332 2.416V13.2a.8.8 0 01-1.6 0v-1.143c0-.694-.563-1.257-1.257-1.257H12.8a.804.804 0 01-.139-.012 2.84 2.84 0 01-.661-.016V14a.8.8 0 11-1.6 0v-3.2A2.4 2.4 0 008 8.4zm0-1.6a1.6 1.6 0 110-3.2 1.6 1.6 0 010 3.2zm-4.4 0a1.2 1.2 0 100 2.4 1.2 1.2 0 000-2.4zm8.8 0a1.2 1.2 0 100 2.4 1.2 1.2 0 000-2.4z"}})])
          )
        }
      }
    